<template>
  <div
    class="bg-w usp-swiper-wrap swiper-wrap"
    style="margin-bottom: 64px;"
    v-if="moduleData.pic1 && moduleData.pic2 && moduleData.pic3"
  >
    <div class="usp-gif-player2">
      <swiper
        ref="mySwiper"
        class="gif-swiper"
        @slideChange="onSlideChange"
        :options="swiperOption"
      >
        <swiper-slide>
          <div class="gif-swiper-image">
            <img :src="moduleData.pic1" alt="" />
            <!-- <div>
              <p class="title">{{moduleData.picText1}}</p>
              <p class="content">{{moduleData.picDes1}}</p>
            </div> -->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="gif-swiper-image">
            <img :src="moduleData.pic2" alt="" />
            <!-- <div>
              <p class="title">{{moduleData.picText2}}</p>
              <p class="content">{{moduleData.picDes2}}</p>
            </div> -->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="gif-swiper-image">
            <img :src="moduleData.pic3" alt="" />
            <!-- <div>
              <p  class="title">{{moduleData.picText3}}</p>
              <p class="content">{{moduleData.picDes3}}</p>
            </div> -->
          </div>
        </swiper-slide>
      </swiper>
      <!-- <div class="gif-swiper-next"></div>
      <div class="gif-swiper-prev"></div> -->
    </div>
    <div
      class="swiper-pagination"
      id="screen-pagination"
      slot="pagination"
    ></div>
    <div
      style="position: absolute;bottom: 0px;left: 50%;transform: translateX(-50%);width: 100%;"
    >
      <div class="content-wrap">
        <div class="usp-app-hz-dots">
          <div
            class="usp-app-hz-dot "
            :class="{ active: gifsActive === 0 }"
            @click="slideTo(0)"
          >
            {{ moduleData.picText1 }}
          </div>
          <div
            class="usp-app-hz-dot"
            :class="{ active: gifsActive === 1 }"
            @click="slideTo(1)"
          >
            {{ moduleData.picText2 }}
          </div>
          <div
            class="usp-app-hz-dot"
            :class="{ active: gifsActive === 2 }"
            @click="slideTo(2)"
          >
            {{ moduleData.picText3 }}
          </div>
          <!-- <div  class="usp-app-hz-dot-slide-bar">
              <div class="usp-app-hz-dot-slider pos-0"></div>
            </div> -->
        </div>
        <p class="desc-wrap">
          {{
            gifsActive === 0
              ? moduleData.picDes1
              : gifsActive === 1
              ? moduleData.picDes2
              : moduleData.picDes3
          }}
        </p>
      </div>
    </div>
    <!-- <div>
      <div class="conetent-wrp">
        <div>
          <p class="title">{{moduleData.picText1}}</p>
          <p class="content">{{moduleData.picDes1}}</p>
        </div>
        <div>
           <p class="title">{{moduleData.picText2}}</p>
            <p class="content">{{moduleData.picDes2}}</p>
        </div>
        <div>
          <p  class="title">{{moduleData.picText3}}</p>
          <p class="content">{{moduleData.picDes3}}</p>
        </div>
      </div>
    </div> -->
    <div class="gif-swiper-title h2-vw">{{ moduleData.topicTitle }}</div>
    <div class="gif-swiper-desc h4-vw">{{ moduleData.bottomDes }}</div>
  </div>
</template>
<script>
import {
  swiper as Swiper,
  swiperSlide as SwiperSlide,
} from "vue-awesome-swiper";
export default {
  name: "swiperScreen",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    moduleData: {
      type: Object,
    },
  },
  data() {
    return {
      gifsActive: 0,
      gifsTitle: "",
      gifsDesc: "",
      swiperOption: {
        // effect: 'coverflow',
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        pagination: {
          el: "#screen-pagination",
          clickable: true,
        },
      },
    };
  },
  methods: {
    onSlideChange() {
      this.gifsActive = this.$refs.mySwiper.swiper.realIndex;
      // this.changeGif(swiper.realIndex);
    },
    changeGif(index) {
      let item = this.gifs[index];
      this.gifsActive = index;
      this.gifsTitle = item.title;
      this.gifsDesc = item.desc;
    },
    slideTo(index) {
      this.$refs.mySwiper.swiper.slideTo(index, 1000, true); //切换到第一个slide，速度为1秒
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
@include setThemeClass {
  .usp-swiper-wrap {
    padding-bottom: 120px;
    position: relative;
    .swiper-pagination-bullets {
      left: 50%;
      bottom: 30px;
      width: 100%;
      transform: translate(-50%, -50%);

      span {
        width: 160px;
        height: 3px;
        margin: 0;
        display: inline-block;
        border-radius: 0;
        margin-right: 3px;
        @include media(
          (
            $home-bg: (
              width: 160px,
              height: 3px,
            ),
            $home-md: (
              width: 145px,
              height: 3px,
            ),
            $home-sm: (
              width: 100px,
              height: 3px,
            ),
          )
        );
      }
    }
  }
  .gif-swiper {
    width: 100%;
    .gif-swiper-image {
      div {
        p {
          margin: 0;
          text-align: center;
          &.title {
            font-size: 20px;
            font-weight: bold;
            color: #747a86;
            line-height: 30px;
            font-weight: 500;
            @include media(
              (
                $home-bg: (
                  font-size: 20px,
                ),
                $home-md: (
                  font-size: 16px,
                ),
                $home-sm: (
                  font-size: 14px,
                ),
              )
            );
          }
          &.content {
            font-size: 16px;
            font-weight: 400;
            color: #131415;
            line-height: 30px;
            text-align: center;
            @include media(
              (
                $home-bg: (
                  font-size: 16px,
                ),
                $home-md: (
                  font-size: 14px,
                ),
                $home-sm: (
                  font-size: 14px,
                ),
              )
            );
          }
        }
      }
    }
    img {
      width: 100%;
    }
  }
  .content-wrap {
    @include media(
      (
        // $home-bg: (
          //   width: 480px,
          // ),
          // $home-md: (
          //   width: 480px,
          // ),
          // $home-sm: (
          //   width: 480px,
          // )
      )
    );
    .usp-app-hz-dots {
      display: flex;
      position: relative;
      justify-content: center;
      font-size: 20px;
      font-weight: bold;
      color: #747a86;
      line-height: 30px;
      font-weight: 500;

      .usp-app-hz-dot {
        margin: 10px 0;
        text-align: center;
        width: 160px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        @include media(
          (
            $home-bg: (
              width: 160px,
            ),
            $home-md: (
              width: 145px,
            ),
            $home-sm: (
              width: 100px,
            ),
          )
        );
        &.active {
          color: #131415;
        }
      }
    }
    .usp-app-hz-dot-slide-bar {
      position: absolute;
      left: 0;
      width: 100%;
      bottom: 0;
      height: 2px;
      background-color: #eeeeee;
    }
    .title-wrap {
      li {
      }
    }
    .bar-wrap {
      li {
      }
    }
    .desc-wrap {
      padding: 0 20px;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 400;
      color: #131415;
      line-height: 30px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @include media(
        (
          $home-bg: (),
          $home-md: (),
          $home-sm: (
            font-size: 14px,
          ),
        )
      );
    }
    p {
      margin: 0;
      text-align: center;
    }
  }
}
</style>
